import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    standalone: true
})
export class ProfileComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
